import React,{ Component } from "react";
import { connect } from "react-redux";
import { updateUser } from "../../../actions/actionAdminUser";
import { Row, Col,  Card, CardHeader, Container} from "reactstrap";
import UserForm from "../UserForm/UserForm";
import Proptypes from "prop-types";
import BreadCrumbCompo from "../../../components/Breadcrumb/BreadCrumbCompo";

const routes = [
    {name: "Home",path:"/userdashboard",isActive: false},
    {name: "Users",path:"/adminUser",isActive: false},
    {name: "UpdateUser",path:"/updateuser",isActive: true},
];

class UpdateUser extends Component{
    render(){
        return (
            <div>     
                <BreadCrumbCompo routes={routes}/> 
                <Row>
                    <Container>
                        <Col sm={{ size: 8, order: 3, offset: 2 }}>
                            <Card className="user-form-container">
                                <CardHeader>
                                    <i className="fa fa-edit"></i> <strong>Update User</strong>
                                </CardHeader>
                                <UserForm
                                    updateUser={this.props.updateUser}
                                    userId={this.props.match.params.id}
                                    fromUpdate={true}
                                />
                            </Card>
                        </Col>
                    </Container>
                </Row>
            </div>
        );
    }
}


UpdateUser.propTypes = {
    updateUser: Proptypes.func.isRequired,
    match: Proptypes.object
};

export default connect(state => ({
    users: state.admin.users || []
}), 
dispatch => ({
    updateUser: () => dispatch(updateUser())
}))(UpdateUser);


// WEBPACK FOOTER //
// ./src/views/AdminUser/UpdateUser/UpdateUser.js